import * as XLSX from 'xlsx'

const downloadFile = (fileName, fileFormat, data) => {

    if (typeof fileName !== 'string' && typeof fileFormat !== 'string' && typeof data !== 'undefined')
        return false
        
    if (fileFormat === 'xlsx') {
        try {
            const workbook = XLSX.utils.book_new()
            const sheet = XLSX.utils.json_to_sheet(data)
            XLSX.utils.book_append_sheet(workbook, sheet,`${fileName}.${fileFormat}`)
            XLSX.writeFile(workbook, `${fileName}.${fileFormat}`, { type: 'file' })
            return true
        } catch (error) {
            return false
        }
      }
      
      if (fileFormat === 'csv') {
        try {
            const workbook = XLSX.utils.book_new()
            const sheet = XLSX.utils.json_to_sheet(data)
            XLSX.utils.book_append_sheet(workbook,sheet,`${fileName}.${fileFormat}`)
            XLSX.writeFile(workbook, `${fileName}.${fileFormat}`, { type: 'file', bookType: 'csv' })
            return true
        } catch (error) {
            return false
        }
      }
}

export default downloadFile